'use client';

import { useRouter, useSearchParams } from 'next/navigation';
import { useTranslations } from 'next-intl';
import { useCallback, useEffect, useState } from 'react';

import { UiKitButton } from '@/ui-kit/button';
import { UiKitDrawer } from '@/ui-kit/drawer';

import { styles } from './GiftCardPaymentFail.styles';

const CERT_RESULT_PARAM = 'certificateResult';
const CERT_RESULT_FAIL = 'fail';

export function GiftCardPaymentFail() {
  const searchParams = useSearchParams();

  const router = useRouter();

  const [open, setOpen] = useState(false);

  const tFail = useTranslations('giftCard.certificateFailModal');

  const slots = styles();

  useEffect(() => {
    setOpen(searchParams.get(CERT_RESULT_PARAM) === CERT_RESULT_FAIL);
  }, [searchParams]);

  const handleClose = useCallback(() => {
    setOpen(false);

    if (searchParams.get(CERT_RESULT_PARAM) === CERT_RESULT_FAIL) {
      const next = new URLSearchParams(searchParams.toString());
      next.delete(CERT_RESULT_PARAM);
      const query = next.toString();
      router.replace(query ? `/?${query}` : '/', { scroll: false });
    }
  }, [router, searchParams]);

  return (
    <UiKitDrawer
      open={open}
      onOpenChange={(isOpen) => !isOpen && handleClose()}
      direction="right"
      contentClassName={slots.base()}
      title={tFail('title')}
    >
      <h2 className={slots.title()}>{tFail('title')}</h2>
      <p className={slots.description()}>{tFail('description')}</p>

      <UiKitButton
        className={slots.button()}
        onClick={handleClose}
      >
        {tFail('continueButton')}
      </UiKitButton>
    </UiKitDrawer>
  );
}
